var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHacken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 9,
    viewBox: "0 0 73 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5228 0.963867V4.45871L66.9915 0.963867H64.516V8.76659H66.9915V5.23534L70.547 8.76659H72.9983V0.963867H70.5228Z",
    fill: "#62718A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0629 8.76659H34.6157V6.59445H28.0629V3.17241H34.6279V0.963867H28.0629H25.8786H25.6238V8.76659H25.8786H28.0629Z",
    fill: "#62718A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2742 8.76659H60.3174V6.59445H54.2742V5.9513H60.3174V3.76702H54.2742V3.14814H60.3174V0.963867H54.2742H52.0293H51.823V8.76659H52.0778H54.2742Z",
    fill: "#62718A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3213 7.01917H18.9618V8.76659H21.4009V0.963867H21.0368H18.9618H15.3213H13.3919H12.8822V4.84703V7.01917V8.76659H15.3213V7.01917ZM15.3213 3.13601H18.9618V4.84703H15.3213V3.13601Z",
    fill: "#62718A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64033 5.99984H6.20798V8.76659H8.65923V0.963867H6.20798V3.68208H2.64033V0.963867H0.189087V8.76659H2.64033V5.99984Z",
    fill: "#62718A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3021 5.97557H45.0882L47.5151 3.65781H47.5394V0.963867H45.0882V3.65781H41.3021V0.963867H38.8508V8.76659H41.3021V5.97557Z",
    fill: "#62718A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5394 5.97559H45.0881V8.76661H47.5394V5.97559Z",
    fill: "#62718A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHacken);
export default __webpack_public_path__ + "static/media/hacken.634cfcf91715f6227f6ccdde5e08f708.svg";
export { ForwardRef as ReactComponent };